import JSON5 from 'json5';

export const setStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getStorage = (key: string) => {
  if (!localStorage) {
    return null;
  }
  const data = localStorage.getItem(key);
  return data ? JSON5.parse(data) : null;
};

export const deleteStorage = (key: string) => {
  if (!localStorage) {
    return null;
  }

  localStorage.removeItem(key);
};
